module.exports = __webpack_public_path__ + "img/enviar.920cdef1.svg";